<template>
  <layout :title-text="title">
    <div slot="content" class="form-container">
      <div class="tabs">
        <div class="tabs-title">
            <ul>
                <li :class="[active === TabType.First ? 'first-hover' : 'first']" @click="tabsClick(TabType.First)"></li>
                <li :class="[active === TabType.Second ? 'second-hover' : 'second']" @click="tabsClick(TabType.Second)"></li>
                <li :class="[active === TabType.Final ? 'final-hover' : 'final']" @click="tabsClick(TabType.Final)"></li>
            </ul>
        </div>
        <div class="tabs-text">
            <div class="text" :class="{'show' : active === TabType.First}">
              <p>线上初赛采用国际上流行的CTF夺旗模式，参赛队伍通过互联网在线解题，题目分为 Web 漏洞与渗透(Web)，软件逆向 (Reverse Engineering)，二进制漏洞挖掘和利用(Pwn)，密码（Crypto）学与杂项（Misc）。每种类型的题有不同的分值，参赛队通过获得 flag 从而得到对应的分值。</p>
              <p>答题积分采用国际惯用的动态积分模式（即每道题目的分值将根据解出队伍的数量进行动态计分，每多一队解出，该题目的分值会随之下降），最终成绩总分由高至低排列，分数相同情况下，以提交时间为准，用时短者排名高于用时较长者。</p>
            </div>
            <div class="text" :class="{'show' : active === TabType.Second}">
              <p>线下选拔赛采用CTF夺旗模式，同时加入公安实际工作场景内容（电子取证、案件侦办等），全方位考核参赛队员综合素质，根据得分多少进行排名，决出晋级队伍。</p>
            </div>
            <div class="text" :class="{'show' : active === TabType.Final}">
              <p>本次比赛采用AWD Plus（大规模攻防兼备赛）的竞赛模式，该模式是一种综合考核参赛团队攻击、防御技术能力、即时策略的比赛模式。比赛过程中，各参赛战队需要同时兼任攻击和防御两种任务。比赛采用零和机制，决赛中，每个战队均拥有相同的起始分数，及相同配置的虚拟靶机，参赛队员需对平台中的GameBox发起攻击，向平台提交正确的flag（证明自己具备对该题的攻击能力）；在此期间，由平台以轮次制的方式向参赛战队的靶机发起攻击，检查其他选手的漏洞是否修补成功，若修补成功则认为参赛战队具备该漏洞的防御能力。最终以各战队得分高低直接分出胜负。</p>
            </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'

const TabType = {
  First: 1,
  Second: 2,
  Final: 3
}

export default {
  components: {
    Layout
  },
  data () {
    return {
      TabType,
      title: '比赛形式',
      active: TabType.First
    }
  },
  methods: {
    tabsClick (index) {
      this.active = index
    }
  }
}
</script>

<style lang="less" scoped>
.form-container {
  position: relative;
  margin: 0 auto;
  height: 300px;
  width: 1000px;
  color: white;
  border: 1px solid #5891FA;
  background-color: #0B1133;
}
.tabs{
  width:100%;
  height: 100%;
  .tabs-title{
    ul {
      margin: 0;
      padding: 0;
      border: none;
      display: flex;
      justify-content: center;
    }
    li{
      flex: 1;
      height: 80px;
      list-style: none;
      float: left;
      text-align: center;
      border: 1px solid #5891FA;
      box-sizing: border-box;
    }
    .first {
      background: url(../../assets/images/tab_match_form1.png);
    }
    .second {
      background: url(../../assets/images/tab_match_form2.png);
    }
    .final {
      background: url(../../assets/images/tab_match_form3.png);
    }
    .first:hover {
      background: url(../../assets/images/tab_match_form1_click.png);
    }
    .second:hover {
      background: url(../../assets/images/tab_match_form2_click.png);
    }
    .final:hover {
      background: url(../../assets/images/tab_match_form3_click.png);
    }
    .first-hover {
      background: url(../../assets/images/tab_match_form1_click.png);
      border-bottom: none;
      border-left: none;
    }
    .second-hover {
      background: url(../../assets/images/tab_match_form2_click.png);
      border-bottom: none;
    }
    .final-hover {
      background: url(../../assets/images/tab_match_form3_click.png);
      border-bottom: none;
      border-right: none;
    }
  }
  .tabs-text {
    padding-top: 10px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 24px;
    p{
      padding: 0 20px;
      text-indent: 2em;
    }
    .text{
      text-align: left;
      width:100%;
      display: none;
    }
    .show {
      display: block;
    }
  }
}

</style>
